import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export const CTASection = () => {
  const scrollTo = (hash) => {
    const el = document.querySelector(hash);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      data-testid="cta-section"
      className="relative py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <div className="relative rounded-3xl overflow-hidden border border-[#E3A21A]/20">
          {/* Layered backgrounds */}
          <div className="absolute inset-0 bg-gradient-to-br from-[#2F3E2E] to-[#1E2A1E]" />
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_20%,rgba(227,162,26,0.25),transparent_50%)]" />
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_10%_80%,rgba(227,162,26,0.12),transparent_50%)]" />

          <div className="relative z-10 p-10 md:p-16 lg:p-24 text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#E3A21A]/25 bg-[#121A12]/40 backdrop-blur-sm mb-8">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#E3A21A] opacity-75" />
                <span className="relative inline-flex rounded-full h-2 w-2 bg-[#E3A21A]" />
              </span>
              <span className="text-xs tracking-[0.25em] uppercase font-semibold text-[#E3A21A]">
                Limited Slots · Accepting 4 New Clients
              </span>
            </div>

            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl xl:text-7xl tracking-tight text-[#F5F5F0] font-medium max-w-4xl mx-auto leading-tight">
              Ready to scale
              <br />
              <span className="text-[#E3A21A] italic font-light">your business?</span>
            </h2>

            <p className="mt-6 text-base md:text-lg text-[#A8B8A8] max-w-2xl mx-auto leading-relaxed">
              Book a free 30-minute strategy call. Walk away with a clear revenue
              plan — whether you work with us or not.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
              <Button
                data-testid="cta-book-consultation"
                onClick={() => scrollTo("#contact")}
                className="group h-14 px-8 rounded-full bg-[#E3A21A] text-[#121A12] font-semibold text-base hover:bg-[#F0B63A] hover:-translate-y-0.5 transition-all shadow-[0_0_40px_rgba(227,162,26,0.35)]"
              >
                Book Free Consultation
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </Button>
              <div className="text-xs text-[#A8B8A8] font-mono tracking-wider">
                NO OBLIGATION · 30 MINS · PAN INDIA
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
